<template>
    <div>
        <product-header 
            :actIndex="actIndex" 
            :imgList="imgList" 
            :topStyle="topStyle" 
            :logo="logo" 
            :productType="productType">
        </product-header>
        <product-type :type="productType" @changeType="productCon" :index="typeIndex"></product-type>
        <product-center :product="productCurrent" ref="productRef"></product-center> 
        <product-footer 
            :bottomNews="bottomNews"
            :bottom="bottom" 
            :bottomInfo="bottomInfo"
            :productType="productType">
        </product-footer>
    </div>
</template>

<script>
import ProductHeader from '@/components/pc/Header'
import ProductType from '@/components/pc/ProductType'
import ProductCenter from '@/components/pc/ProductCenter'
import ProductFooter from '@/components/pc/Footer'
export default {
    name: 'Product',
    data () {
        return {
            screenStyle: {
                width: '',
                margin: "0 auto",
            },
            topStyle: "",
            actIndex: 2,
            imgList: [],
            bottom: {},
            logo: '',
            bottomInfo: {},
            productCurrent:[],
            productType: [],
            productList: {},
            productAll: [],
            productName: '',
            bottomNews: []
        }
    },
    components: {
        ProductHeader,
        ProductType,
        ProductCenter,
        ProductFooter,
    },
    created () {
    },
    mounted () {
        // this.Pc_Mobile()
        this.productName = this.$route.params.name
        this.getPageData()
    },
    methods: {
        _isMobile() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return flag;
        },
        // Pc_Mobile () {
        //     if(this._isMobile()) {
        //         this.$router.replace('/m_product');
        //     }else{
        //         this.$router.replace('/product');
        //     }
        // },
        getPageData () {
            this.$http.post('home/index/product',null, (res) => { 
                // console.log(res.data)
                this.bottom = res.data.bottom[0]
                this.logo = this.bottom.logo
                this.topStyle = "background-image:url('"+this.$imgUrl+res.data.header[0].cpzx.replace(/\\/g,'/')+"')"
                this.bottomInfo = res.data.contact[0]
                this.productType = res.data.type
                this.productAll = res.data.product
                this.bottomNews = res.data.b_news
                this.$nextTick(()=>{
                    this.$refs.productRef.imgSwiper1('.product-top-swiper-container')
                    this.$refs.productRef.imgSwiper2('.product-bottom-swiper-container','.swiper-swiper-prev','.swiper-swiper-next','my-button-disabled')
                })
            })
        },
        productCon (name) {
            this.productCurrent = this.productList[name];
            // console.log(222222)
            this.$nextTick(()=>{
                // console.log(1111111)
                this.$refs.productRef.imgSwiper1('.product-top-swiper-container')
                this.$refs.productRef.imgSwiper2('.product-bottom-swiper-container','.swiper-swiper-prev','.swiper-swiper-next','my-button-disabled')
            })
            // console.log(this.productCurrent)
        }
    },
    watch: {
        productAll(){
            var pages = {}
            this.productAll.forEach((item)=>{
                var type = item.type
                if(!pages[type]){
                    pages[type]=[]
                }
                pages[type].push(item)
            })
            this.productList = pages
            this.productCon(this.productName)
        },
        $route(){
            this.productName = this.$route.params.name
            if(!this.productName) return
            this.productCon(this.productName)
        }
    },
    computed: {
        typeIndex(){
            var type = this.productType
            for(var i=0;i<type.length;i++){
                if(this.productName == type[i].name){
                    return i
                }
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
    
</style>


// WEBPACK FOOTER //
// src/views/pc/Product.vue